import { FontAwesome5, MaterialCommunityIcons } from '@expo/vector-icons';
import {
  DrawerContentComponentProps,
  DrawerContentOptions,
  DrawerContentScrollView,
  DrawerItem
} from '@react-navigation/drawer';
import React from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { Drawer, Text, useTheme } from 'react-native-paper';
import colors from '../../colors';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Touchable from '../Generic/Touchable';
import Footer from '../Generic/Footer';
import UserInfo from './UserInfo';
import { Ionicons } from '@expo/vector-icons';

// import { AuthContext } from '../components/context';
type Props = DrawerContentComponentProps<DrawerContentOptions>;

export const DrawerContent: React.FC<Props> = (props) => {
  const { navigation } = props;
  const paperTheme = useTheme();

  const [sessao, login, logout] = useSessao();

  if (!sessao.token) {
    return (
      <View style={{ flex: 1 }}>
        <Touchable
          onPress={() => navigation.navigate('LoginPage')}
          style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
        >
          <FontAwesome5
            name="sad-cry"
            size={60}
            color={colors.darkGrey}
            style={{ marginBottom: 10 }}
          />
          <Text style={{ fontSize: 18, color: colors.darkGrey, textAlign: 'center', margin: 5 }}>
            Você ainda não fez login...
          </Text>
          <Text style={{ fontSize: 18, color: colors.darkGrey, textAlign: 'center', margin: 5 }}>
            Clique aqui para entrar ou se cadastrar!
          </Text>
        </Touchable>

        <Footer />
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <DrawerContentScrollView {...props}>
        <View style={styles.drawerContent}>
          <UserInfo />

          <Drawer.Section style={styles.drawerSection}>
            <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="food" color={color} size={size} />
              )}
              label="Produtos"
              onPress={() => {
                navigation.navigate('ProdutosPage');
              }}
            />
            <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="silverware-fork-knife" color={color} size={size} />
              )}
              label="Meu Pedidos"
              onPress={() => {
                navigation.navigate('PedidosPage');
              }}
            />
            {/* <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="account-outline" color={color} size={size} />
              )}
              label="Meus Dados"
              onPress={() => {}}
            /> */}
            {/* <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="bookmark-outline" color={color} size={size} />
              )}
              label="Meus Pedidos"
              onPress={() => {}}
            /> */}
            {/* <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="settings-outline" color={color} size={size} />
              )}
              label="Configurações"
              onPress={() => {}}
            /> */}
            {/* <DrawerItem
              icon={({ color, size }) => (
                <MaterialCommunityIcons name="account-check-outline" color={color} size={size} />
              )}
              label="Suporte"
              onPress={() => {}}
            /> */}
          </Drawer.Section>

          {/* <Drawer.Section title="Preferences">
            <TouchableRipple
              onPress={() => {
                toggleTheme();
              }}
            >
              <View style={styles.preference}>
                <Text>Dark Theme</Text>
                <View pointerEvents="none">
                  <Switch value={paperTheme.dark} />
                </View>
              </View>
            </TouchableRipple>
          </Drawer.Section> */}
        </View>
      </DrawerContentScrollView>

      <Footer />

      <DrawerItem
        icon={({ color, size }) => (
          <MaterialCommunityIcons name="exit-to-app" color={color} size={size} />
        )}
        label="Sair"
        onPress={() => {
          logout();
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  drawerContent: {
    flex: 1
  },
  userInfoSection: {
    paddingLeft: 20
  },
  title: {
    fontSize: 16,
    marginTop: 3,
    fontWeight: 'bold'
  },
  caption: {
    fontSize: 14,
    lineHeight: 14
  },
  row: {
    marginTop: 20,
    flexDirection: 'row',
    alignItems: 'center'
  },
  section: {
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 15
  },
  paragraph: {
    fontWeight: 'bold',
    marginRight: 3
  },
  drawerSection: {
    marginTop: 15
  },
  bottomDrawerSection: {
    marginBottom: 15,
    borderTopColor: '#f4f4f4',
    borderTopWidth: 1
  },
  preference: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 12,
    paddingHorizontal: 16
  }
});
